import * as React from 'react';
import withSnackbar from './util/withSnackbar';
import { injectIntl } from "react-intl";
import { SNACKBAR_OPTIONS } from './constants/CommonConstants';

class ErrorBoundary extends React.Component {
  constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }
 
    componentDidCatch() {
       this.props.redirectScreen(this.props);
    }
 
    render() {
        if (this.state.hasError) {
            // htmlタグを含めないとcatchしてくれないため、空のdivタグを返す
            return <div></div>;
        }
        // エラーがない時は画面componentを表示
        return this.props.children;
    }
}

export default withSnackbar(injectIntl(ErrorBoundary), SNACKBAR_OPTIONS);